export const getErrorIs404NotFound = error => {
  return error.message.includes('404');
};